'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dPage$0024 from "./presto.-Agent-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002441 from "./presto.-Presto-Router$$anon$41.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$40() {
  this.bia = null;
  this.bi2 = null;
  this.bi3 = false;
  this.bib = null;
  this.bic = false;
  this.bif = null;
  this.bi8 = null;
  this.bi9 = false;
  this.bi4 = null;
  this.bi5 = false;
  this.bi6 = null;
  this.bi7 = false;
  this.bid = false;
  this.bie = false;
  this.bia = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bif = "AgentPage";
}
export { $c_Lpresto_PrestoRouter$$anon$40 as $c_Lpresto_PrestoRouter$$anon$40 };
$p = $c_Lpresto_PrestoRouter$$anon$40.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$40;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$40() {
}
export { $h_Lpresto_PrestoRouter$$anon$40 as $h_Lpresto_PrestoRouter$$anon$40 };
$h_Lpresto_PrestoRouter$$anon$40.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bia;
});
$p.L = (function() {
  if ((!this.bi3)) {
    this.bi2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bi3 = true;
  }
  return this.bi2;
});
$p.O = (function() {
  if ((!this.bic)) {
    this.bib = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bic = true;
  }
  return this.bib;
});
$p.E = (function() {
  return this.bif;
});
$p.t = (function() {
  if ((!this.bi9)) {
    this.bi8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bi9 = true;
  }
  return this.bi8;
});
$p.M = (function() {
  if ((!this.bi5)) {
    this.bi4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bi5 = true;
  }
  return this.bi4;
});
$p.Q = (function() {
  if ((!this.bi7)) {
    this.bi6 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002441.$c_Lpresto_PrestoRouter$$anon$41();
    this.bi7 = true;
  }
  return this.bi6;
});
$p.w = (function() {
  if ((!this.bie)) {
    this.bid = false;
    this.bie = true;
  }
  return this.bid;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee356) => ((p) => \u03b4scrutinee356))($j_presto$002e$002dAgent$002dPage$0024.$m_Lpresto_AgentPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$40 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$40, "presto.PrestoRouter$$anon$40", ({
  O6: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$40 as $d_Lpresto_PrestoRouter$$anon$40 };
//# sourceMappingURL=presto.-Presto-Router$$anon$40.js.map
